import { render, staticRenderFns } from "./statementDetails.vue?vue&type=template&id=2ee8e6d6&scoped=true&"
import script from "./statementDetails.vue?vue&type=script&lang=js&"
export * from "./statementDetails.vue?vue&type=script&lang=js&"
import style0 from "./statementDetails.vue?vue&type=style&index=0&id=2ee8e6d6&lang=less&scoped=true&"
import style1 from "./statementDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8e6d6",
  null
  
)

export default component.exports